export const baseEndpoint = '/apis/searchapi/search';
export const baseSettingsEndpoint = '/apis/searchapi/settings';
